import React, { useRef, useState } from "react";
import { Link, Navigate, useSearchParams } from "react-router-dom";
import {
  Backdrop,
  Snackbar,
  CircularProgress,
  Typography,
  Grid,
  Container,
  TextField,
  Button,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import "./login.css";
import { IoMdLock } from "react-icons/io";
import {
  login,
  sendResetPasswordLink,
} from "../../api-interactions/authentication";

export const Login = () => {
  const emailRef = useRef();
  const resetPwRef = useRef();
  const passwordRef = useRef();

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState();
  const [error, setError] = useState();
  const [pwReset, setPwReset] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  if (document.cookie && localStorage.getItem("user")) {
    const redirect = searchParams.get("next") || "dashboard";
    return <Navigate to={"/" + redirect} />;
  }

  // const signInWithGoogle = () => {};

  const submitHandler = async (e) => {
    e.preventDefault();

    setError("");
    setLoading(true);

    const err = await login({
      email: emailRef.current.value,
      password: passwordRef.current.value,
    });
    if (err === undefined) {
      const redirect = searchParams.get("next") || "dashboard";
      console.log(redirect);
      <Navigate to={"/" + redirect} />;
    } else {
      setError(err);
    }
    setLoading(false);
    setTimeout(() => {
      setError("");
    }, 6000);
  };

  const resetPwHandler = (e) => {
    e.preventDefault();
    const email = resetPwRef.current.value;
    sendResetPasswordLink({ email });
    setPwReset(false);
    setSuccess("Reset link has been send!");
  };

  return (
    <React.Fragment>
      <Container id="signin-container" maxWidth="xs">
        <IoMdLock id="lock" />
        <Typography id="signin-text" component="h1" variant="h5">
          Sign in
        </Typography>
        {error && (
          <Snackbar open={true} autoHideDuration={6000}>
            <Alert severity="error">{error}</Alert>
          </Snackbar>
        )}
        {success && (
          <Snackbar open={true} autoHideDuration={6000}>
            <Alert severity="success">{success}</Alert>
          </Snackbar>
        )}
        <form id="signin-form">
          <TextField
            inputRef={emailRef}
            type="email"
            required
            variant="outlined"
            label="Email Address"
            className="signin-form-input"
          />
          <TextField
            type="password"
            id="password"
            inputRef={passwordRef}
            required
            variant="outlined"
            label="Password"
            className="signin-form-input"
          />
          {!loading ? (
            <Button
              onClick={submitHandler}
              type="submit"
              variant="contained"
              color="primary"
              id="signin-btn"
            >
              Sign in
            </Button>
          ) : (
            <CircularProgress color="primary" />
          )}
          <Grid container>
            <Grid item xs>
              <a
                onClick={() => {
                  setPwReset(true);
                }}
                className="small-txt"
              >
                Forgot password?
              </a>
            </Grid>
            <Grid item>
              <Link to="/signup" className="small-txt">
                Don't have an account? Sign Up
              </Link>
            </Grid>
          </Grid>
        </form>
        <Typography variant="h6" id="or-text"></Typography>
        {/* <div className="google-btn" onClick={signInWithGoogle}>
          <div className="google-icon-wrapper">
            <img
              alt="google"
              className="google-icon"
              src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"
            />
          </div>
          <p className="btn-text">
            <b>Sign in with google</b>
          </p>
        </div> */}
      </Container>
      {pwReset && (
        <div>
          <div
            id="backdrop"
            onClick={() => {
              setPwReset(false);
            }}
          ></div>
          <div>
            <Container id="reset-pw-container">
              <Typography id="reset-pw-text" variant="h5">
                Reset your password
              </Typography>
              <form id="reset-pw-form">
                <TextField
                  inputRef={resetPwRef}
                  type="email"
                  required
                  label="Email Address"
                  id="reset-pw-input"
                  defaultValue={emailRef.current.value}
                />
                <Button
                  onClick={resetPwHandler}
                  type="submit"
                  variant="contained"
                  id="reset-pw-btn"
                >
                  Reset password
                </Button>
              </form>
            </Container>
            {loading && (
              <Backdrop open="open" id="loading-backdrop">
                <CircularProgress color="primary" />
              </Backdrop>
            )}
          </div>
        </div>
      )}
    </React.Fragment>
  );
};
